import React from 'react';

import styles from './index.less';

const Field = ({ label, value, ...rest }) => (
  <p className={styles.field} {...rest}>
    <span>{label}</span>
    <span>{value}</span>
  </p>
);

export default Field;



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/Charts/Field/index.js